/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import Head from "next/head";
// import Image from "next/image";
import Header from "./common/Header";
import Footer from "./common/Footer";
// import aboutImage from "/public/assets/images/about-img.jpg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getaboutusData } from "../store/actions/aboutUsAction";

const aboutus = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getaboutusData());
  }, [dispatch]);
  const aboutUsData = useSelector((state) => state.aboutUsInfo.aboutUsInfo.data);
  // console.log(aboutUsData,'Props +++')
  return (
    <div>
      <Head>
        <title>Residen | A propos</title>
      </Head>
      <Header />
      <div className="innerBannerWrapper">
        <div className="container">
          <div className="innerBannerCaption">
            <h1>A propos</h1>
            {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
          </div>
        </div>
      </div>
      <div className="padding-top padding-bottom aboutusWrapper">
      {(aboutUsData && aboutUsData.length>0) ? <>
        <div className="container cmn-info-style" dangerouslySetInnerHTML={{ __html: aboutUsData[0].content }} />
         </>: null}
      </div>
      <Footer />
    </div>
  );
};

export default aboutus;
